<template>
  <v-form @submit.prevent>
      <pictos-form :doc="doc" @update="update" />
      <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import PictosForm from "./PictosForm"
import router from "@/router";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserPictosAdd",
  components: {
    PictosForm
  },
  data () {
    return {
      doc: {}
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let ref = fb.signsCollection.doc();
      ref.set({
        createdOn: new Date(),
        id: ref.id,
        title_en: this.populateField(this.doc.title_en),
        title_ar: this.populateField(this.doc.title_ar),
        title_fr: this.populateField(this.doc.title_fr),
        description_en: this.populateField(this.doc.description_en),
        description_ar: this.populateField(this.doc.description_ar),
        description_fr: this.populateField(this.doc.description_fr),
        pictos: this.populateField(this.doc.pictos),
        format: this.populateField(this.doc.format),
        digital: this.populateField(this.doc.digital),
        physical: this.populateField(this.doc.physical),
        stage: this.populateField(this.doc.stage),
        location: this.populateField(this.doc.location)
      }).then(() => {
        router.push({ name: 'UserPictos' })
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    },
    populateField(field) {
      return field ? field : null
    },
    update(val) {
      console.log('upodate')
      this.doc.pictos = val;
    }
  }
};
</script>
